import {Routes, RouterModule, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {CalendarComponent} from './calendar/calendar.component';
import {CoursesGroupsComponent} from './courses-groups/courses-groups.component';
import {DetailedRegistration} from './datamodel/registration';
import {BackendService} from './backend.service';
import {CoursesGroupComponent} from './course-group/courses-group.component';
import {CourseComponent} from './course/course.component';
import {ClassgroupComponent} from './classgroup/classgroup.component';
import {Course} from './datamodel/course';
import {Observable} from 'rxjs';
import {Injectable, NgModule} from '@angular/core';

@Injectable({providedIn: 'root'})
export class DetailedRegistrationResolver implements Resolve<DetailedRegistration> {
  constructor(public service: BackendService, public router: Router) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.service.getDetailedRegistration(decodeURIComponent(route.paramMap.get('id')));
  }
}

@Injectable({providedIn: 'root'})
export class CourseResolver implements Resolve<Course> {
  constructor(public service: BackendService) {
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.service.getCourse(
      decodeURIComponent(route.paramMap.get('course_id')),
      decodeURIComponent(route.paramMap.get('term_id')),
      decodeURIComponent(route.paramMap.get('id')));
  }
}

export const routes: Routes = [
  {
    path: 'registrations', children: [
      {path: '', component: CalendarComponent},
      {
        path: ':id', resolve: {registration: DetailedRegistrationResolver},
        children: [
          {path: '', component: CoursesGroupsComponent},
          {path: ':course_group_id', component: CoursesGroupComponent},
          {path: ':course_group_id/:course_id/:term_id', component: CourseComponent},
          {
            path: ':course_group_id/:course_id/:term_id/:unit_id/:group_number',
            component: ClassgroupComponent,
            resolve: {course: CourseResolver}
          }
        ]
      }
    ]
  },
  {path: '', redirectTo: '/registrations', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
